import {take, delay, put} from 'redux-saga/effects';

export function* print() {
  while (yield take('UI_PRINT')) {
    yield delay(20);
    window.print();
    yield put({
      type: 'UI_PRINT_RESET',
      target: undefined,
    });
  }
}
